export const calculationServices = {
    settlementFundsForInitials: {
        id: 1,
        name: 'Liquidação de Verbas Trabalhistas para Iniciais',
        key: 'settlementFundsForInitials'
    },
};
